import { render, staticRenderFns } from "./ZoomableContent.vue?vue&type=template&id=71027f0a&scoped=true"
import script from "./ZoomableContent.vue?vue&type=script&lang=js"
export * from "./ZoomableContent.vue?vue&type=script&lang=js"
import style0 from "./ZoomableContent.vue?vue&type=style&index=0&id=71027f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71027f0a",
  null
  
)

export default component.exports